import { type Manifest, type RouterConfig, PAGE_TYPE } from '@/types/manifest.ts';

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.PAGE,
    name: 'debug',
    exclusiveRoutePath: '/debug',
    getComponent: () => import('./Debug.vue'),
};

export const manifest: Manifest = {
    ...routerConfig,
};
